export const state = {
    accessToken: undefined,
    accessTokenPromise: undefined
};

export type State = typeof state;
